import { useState, type ReactNode } from 'react';

import { Campo, Painel } from '../../comum';
import type { PropsSecao } from './comum';

/**
 * Vigia da fila de chamados.
 */
export function SecaoVigia({ c, podeEditar, acao, salvar }: PropsSecao): ReactNode {
  const [vigia, setVigia] = useState(c.vigia);

  return (
    <Painel
      titulo="Vigia da fila de chamados"
      sub="Avisa antes do problema acontecer, pelos destinos configurados em Integrações."
    >
      <label style={{ display: 'flex', gap: 8 }}>
        <input
          type="checkbox"
          checked={vigia.ativo}
          disabled={!podeEditar}
          onChange={(e) => setVigia({ ...vigia, ativo: e.target.checked })}
        />
        <span>
          Vigiar a fila de chamados
          <span className="ajuda">
            Desligado por padrão: ligar numa instalação nova mandaria a fila inteira para os
            destinos no primeiro dia, incluindo chamados antigos que ninguém considera problema.
          </span>
        </span>
      </label>

      <div className="grade2">
        <Campo
          rotulo="Avisar quando faltarem (horas)"
          ajuda="O aviso se repete quando o prazo aperta: 24h, 8h e 2h. Cada faixa avisa uma vez."
        >
          <input
            type="number"
            min={1}
            max={168}
            value={vigia.slaHoras}
            disabled={!podeEditar || !vigia.ativo}
            onChange={(e) => setVigia({ ...vigia, slaHoras: Number(e.target.value) })}
          />
        </Campo>
        <Campo
          rotulo="Sem responsável há (horas)"
          ajuda="Carência antes de cobrar. Chamado recém-aberto sem dono é normal; o problema é o que fica."
        >
          <input
            type="number"
            min={1}
            max={168}
            value={vigia.semDonoHoras}
            disabled={!podeEditar || !vigia.ativo}
            onChange={(e) => setVigia({ ...vigia, semDonoHoras: Number(e.target.value) })}
          />
        </Campo>
        <Campo
          rotulo="Parado há (dias)"
          ajuda="Sem movimentação — não 'antigo'. Comentário no KACE conta como movimentação."
        >
          <input
            type="number"
            min={1}
            max={90}
            value={vigia.paradoDias}
            disabled={!podeEditar || !vigia.ativo}
            onChange={(e) => setVigia({ ...vigia, paradoDias: Number(e.target.value) })}
          />
        </Campo>
      </div>

      <button
        className="primario"
        disabled={acao.executando || !podeEditar}
        onClick={() => salvar('vigia', vigia, 'Vigia da fila')}
      >
        Salvar
      </button>
    </Painel>
  );
}
